module.exports = __webpack_public_path__ + "img/Bg.a09b8191.png";